import { IOffer } from '../types/quote/offer';
import {
  SET_PROVIDER_PROFILE_ITEM,
  UPDATE_PROVIDER_PROFILE_ITEM_STATUS,
} from './types';

export function setProviderProfileItemAction(payload: {
  [id: string]: IOffer;
}) {
  return {
    type: SET_PROVIDER_PROFILE_ITEM,
    payload,
  };
}

export function updateProviderProfileItemStatusAction(payload: {
  field: string;
  status: string;
}) {
  return {
    type: UPDATE_PROVIDER_PROFILE_ITEM_STATUS,
    payload,
  };
}
